import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import EmailInput from "../../reusable-components/email-input";
import Button from "../../reusable-components/button";

const CustomHRDForm = ({
  email,
  emailError,
  handleEmailChange,
  handleNext,
}) => {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    handleNext();
  };

  return (
    <div className="hrd-form-view">
      <form onSubmit={handleSubmit}>
        <EmailInput
          value={email}
          errorMessage={emailError}
          onChange={handleEmailChange}
        />

        <Button
          buttonText={t("customHRD.nextButton")}
          onClick={handleNext}
        />
      </form>
    </div>
  );
};

CustomHRDForm.propTypes = {
  email: PropTypes.string.isRequired,
  emailError: PropTypes.string,
  handleEmailChange: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default CustomHRDForm;